import { ControlFacet } from '../models/controls/ControlFacet';
import { IItemColumn } from '../models/schema/IItemColumn';
import { IDetailsListProps } from 'office-ui-fabric-react/lib/DetailsList';
import { IWithViewportProps } from 'office-ui-fabric-react/lib/utilities/decorators/withViewport';

export type IItemColumnListProps = {
  columns?: IItemColumn[];
} & Partial<Pick<IDetailsListProps,
'layoutMode' |
'onColumnResize' |
'columnReorderOptions'
>> & Partial<Pick<IWithViewportProps,
'skipViewportMeasures'
>>;

export const itemSetColumnsControl: ControlFacet<{
  itemSetKey: string | undefined;
}, IItemColumnListProps> = new ControlFacet('itemSetColumns');
